<div class="grid h-[72px] cursor-pointer grid-cols-[12%_80%_8%] items-center" (click)="redirectToSchedule()">
    <rwidget-route-short-name
        [label]="favoriteSchedule.route?.shortName"
        [color]="favoriteSchedule.route?.color"></rwidget-route-short-name>
    <div class="desc">
        <div class="text-base">{{ favoriteSchedule.route?.longName }}</div>
        <div class="bus-stop text-sm text-[#5E5E5E]">{{ favoriteSchedule.stop?.name }}</div>
    </div>
    <div class="action cursor-pointer text-right">
        <img class="h-8 w-8" [src]="(assetsPath$ | async) + '/img/explore/arrow-right.svg'" alt="Arrow right" />
    </div>
</div>
